import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-input"
export default class extends Controller {
  
  static targets = ["input"]
  
  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
    } else {
      this.inputTarget.type = "password"
    }
  }
  
}
